import { Injectable } from '@angular/core';
import { IAclMenuDetails } from '../../interface/acl/acl.interface';
import { IMenuSubMenuHeaderConfiguration } from '../../interface/header-configuration/menu-sub-menu-header-configuration.interface';

@Injectable({
  providedIn: 'root',
})
export class MenuSubMenuHeaderConfigurationService {
  private menuInfo: IMenuSubMenuHeaderConfiguration = {
    menuId: '',
    menuName: '',
    subMenuId: '',
    subMenuName: '',
  };

  public getMenuInfo(): IMenuSubMenuHeaderConfiguration {
    return this.menuInfo;
  }

  public setMenuInfo(obj: IAclMenuDetails) {
    this.menuInfo.menuId = obj.menu_id;
    this.menuInfo.menuName = obj.menu_name;
    this.menuInfo.subMenuId = obj.submenu_id;
    this.menuInfo.subMenuName = obj.submenu_name;
  }
}
